import React from 'react';
import { FileTextOutlined } from '@ant-design/icons';

const TermsAndConditions = () => {
  return (
    <div className="container py-5 terms-page">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-9">
          {/* Header Section */}
          <div className="text-center mb-5">
            <div 
              className="d-inline-flex align-items-center justify-content-center mb-4 terms-header-icon"
              style={{
                width: '90px',
                height: '90px',
                borderRadius: '24px',
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                boxShadow: '0 8px 24px rgba(13, 110, 253, 0.3)'
              }}
            >
              <FileTextOutlined className="terms-header-icon-svg" style={{ fontSize: '45px', color: '#fff' }} />
            </div>
            <h1 
              className="display-4 fw-bold mb-3 terms-main-title"
              style={{
                background: 'linear-gradient(135deg, rgb(13, 110, 253) 0%, rgb(0, 80, 179) 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              MaveshiBids User Agreement
            </h1>
            <p className="lead text-muted mb-0 terms-subtitle">
              MaveshiBids – Code of Conduct & Operating Guidelines
            </p>
            <p className="text-muted mt-3 mb-0 terms-updated-date" style={{ fontSize: '0.9rem' }}>
              Last updated: {new Date().toLocaleDateString()}
            </p>
        </div>

          {/* Content */}
          <div className="card border-0 shadow-sm mb-4 terms-content-card" style={{ borderRadius: '16px' }}>
            <div className="card-body p-4 p-md-5 terms-content-body">
              {/* Section 1 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  1. Our Mission
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  MaveshiBids is Pakistan's first real-time digital livestock market, connecting buyers and sellers across cities and villages through a safe, transparent, and fair auction process.
                </p>
                <p className="text-muted mb-0 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We aim to modernize traditional mandi culture — bringing the same trust, negotiation, and verification — into a digital space accessible to everyone.
                </p>
              </div>

              {/* Section 2 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  2. Core Principles
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  All MaveshiBids users — buyers, sellers, and agents — must act with:
                </p>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li><strong>Honesty</strong> – Accurate listing information, no misrepresentation or manipulation.</li>
                  <li><strong>Fairness</strong> – Equal opportunity for all registered bidders.</li>
                  <li><strong>Transparency</strong> – Clear communication, verifiable pricing, and open dispute resolution.</li>
                  <li><strong>Accountability</strong> – Compliance with all platform policies, including payment, delivery, and verification.</li>
                </ul>
              </div>

              {/* Section 3 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  3. Registration & Verification
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  To maintain platform trust:
                </p>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>All users must verify their identity via CNIC, bank account, and WhatsApp OTP.</li>
                  <li>Sellers must provide authentic animal photos/videos, verified through our AI-based inspection system (with optional vet confirmation).</li>
                  <li>Buyers may be required to deposit a small refundable security amount before participating in premium or private auctions to prevent false bidding.</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  4. Listing Standards
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  Each listing must:
                </p>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>Represent the actual animal(s) offered for sale.</li>
                  <li>Include clear photos, videos, and full descriptions (breed, age, health, category – e.g., Breeder, Qurbani, Meat).</li>
                  <li>Declare any known defects, diseases, or injuries.</li>
                  <li>Be withdrawn only before the auction starts, unless under exceptional circumstances approved by MaveshiBids Support.</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  5. Bidding Rules
                </h2>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>All bids are binding — a successful bidder must complete payment within the stated time.</li>
                  <li>Soft close applies: bids placed within the final 2 minutes extend the timer by 1 minute to ensure fair competition.</li>
                  <li>Sellers cannot bid on their own listings or manipulate prices through fake buyers.</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  6. Private & Weekly Auctions
                </h2>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li><strong>Weekly Markets:</strong> Simulate physical mandis online; multiple sellers list simultaneously.</li>
                  <li><strong>Private Auctions:</strong> Invite-only events (up to 30 verified buyers). Premium animals or breeder stock only.</li>
                  <li><strong>Part-Lot Sales:</strong> Buyers may purchase part of a lot at per-head rates if enabled by seller.</li>
        </ul>
              </div>

              {/* Section 7 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  7. Payment & Delivery
                </h2>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>Payments are to be made through verified channels (bank transfer or approved payment gateway).</li>
                  <li>Buyer and seller agree on delivery or pickup terms at checkout.</li>
                  <li>MaveshiBids can offer escrow-like holding for secure high-value transactions.</li>
                </ul>
              </div>

              {/* Section 8 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  8. Dispute Resolution
                </h2>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>Disputes must be raised within 24 hours of transaction confirmation.</li>
                  <li>Evidence (photos, video, vet reports) will be reviewed by MaveshiBids moderators.</li>
                  <li>Repeated offenders or fraudulent users will be blacklisted and publicly marked as unverified.</li>
                </ul>
              </div>

              {/* Section 9 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  9. Reputation & Trust Score
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  Every transaction affects your Trust Score:
                </p>
                <div className="table-responsive terms-table-wrapper">
                  <table className="table table-bordered terms-table" style={{ fontSize: '0.95rem' }}>
                    <thead style={{ background: '#f8f9fa' }}>
                      <tr>
                        <th className="fw-bold">Action</th>
                        <th className="fw-bold">Effect</th>
                      </tr>
                    </thead>
                    <tbody className="text-muted">
                      <tr>
                        <td>Successful sale & positive rating</td>
                        <td>+ Points</td>
                      </tr>
                      <tr>
                        <td>Payment delay / bid cancellation</td>
                        <td>− Points</td>
                      </tr>
                      <tr>
                        <td>Verified ID & Bank Account</td>
                        <td>+ Points</td>
                      </tr>
                      <tr>
                        <td>Dispute raised and confirmed against user</td>
                        <td>− Points</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="text-muted mt-3 mb-0 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  High trust scores unlock breeder-only auctions, discounted listing fees, and early access to featured sales.
                </p>
              </div>

              {/* Section 10 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  10. Platform Integrity
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  MaveshiBids reserves the right to:
                </p>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>Suspend or remove users violating policy.</li>
                  <li>Hold payments if fraudulent activity is suspected.</li>
                  <li>Modify auction rules to ensure fair, competitive operation.</li>
                </ul>
              </div>

              {/* Section 11 */}
              <div className="mb-5 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  11. Compliance & Legal
                </h2>
                <ul className="text-muted terms-list" style={{ lineHeight: '2', fontSize: '1rem' }}>
                  <li>All users must comply with Pakistan's e-commerce, livestock, and animal welfare laws.</li>
                  <li>False listings or misrepresentation may result in legal action under the relevant sections of the Pakistan Penal Code.</li>
                </ul>
              </div>

              {/* Section 12 */}
              <div className="mb-0 terms-section">
                <h2 className="fw-bold mb-3 terms-section-title" style={{ color: '#212529', fontSize: '1.75rem' }}>
                  12. Our Commitment
                </h2>
                <p className="text-muted mb-3 terms-section-text" style={{ lineHeight: '1.8', fontSize: '1rem' }}>
                  We're here to make livestock trade more secure, efficient, and rewarding — for both farmers and buyers.
                </p>
                <p className="text-muted mb-0 fw-semibold terms-commitment-text" style={{ lineHeight: '1.8', fontSize: '1rem', color: '#0d6efd' }}>
                  By joining MaveshiBids, you agree to trade honestly, build trust, and help modernize Pakistan's livestock economy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        /* Responsive Styles */
        .terms-page {
          padding-top: 20px !important;
          padding-bottom: 40px !important;
        }

        /* Header Section - Mobile */
        .terms-header-icon {
          width: 70px !important;
          height: 70px !important;
        }

        .terms-header-icon-svg {
          font-size: 35px !important;
        }

        .terms-main-title {
          font-size: 2rem !important;
        }

        .terms-subtitle {
          font-size: 1rem !important;
        }

        .terms-updated-date {
          font-size: 0.85rem !important;
        }

        /* Content Card - Mobile */
        .terms-content-card {
          border-radius: 16px !important;
        }

        .terms-content-body {
          padding: 20px !important;
        }

        .terms-section {
          margin-bottom: 2rem !important;
        }

        .terms-section-title {
          font-size: 1.4rem !important;
        }

        .terms-section-text {
          font-size: 0.9rem !important;
          line-height: 1.7 !important;
        }

        .terms-list {
          font-size: 0.9rem !important;
          line-height: 1.8 !important;
          padding-left: 20px !important;
        }

        .terms-table-wrapper {
          overflow-x: auto;
          margin: 1rem 0;
        }

        .terms-table {
          font-size: 0.85rem !important;
          min-width: 100%;
        }

        .terms-table th,
        .terms-table td {
          padding: 8px 12px !important;
          white-space: nowrap;
        }

        .terms-commitment-text {
          font-size: 0.9rem !important;
        }

        /* Tablet and up */
        @media (min-width: 768px) {
          .terms-page {
            padding-top: 40px !important;
            padding-bottom: 60px !important;
          }

          .terms-header-icon {
            width: 90px !important;
            height: 90px !important;
          }

          .terms-header-icon-svg {
            font-size: 45px !important;
          }

          .terms-main-title {
            font-size: 2.5rem !important;
          }

          .terms-subtitle {
            font-size: 1.1rem !important;
          }

          .terms-updated-date {
            font-size: 0.9rem !important;
          }

          .terms-content-body {
            padding: 32px !important;
          }

          .terms-section-title {
            font-size: 1.75rem !important;
          }

          .terms-section-text {
            font-size: 1rem !important;
            line-height: 1.8 !important;
          }

          .terms-list {
            font-size: 1rem !important;
            line-height: 2 !important;
            padding-left: 24px !important;
          }

          .terms-table {
            font-size: 0.95rem !important;
          }

          .terms-table th,
          .terms-table td {
            padding: 12px 16px !important;
            white-space: normal;
          }

          .terms-commitment-text {
            font-size: 1rem !important;
          }
        }

        /* Desktop and up */
        @media (min-width: 992px) {
          .terms-main-title {
            font-size: 3rem !important;
          }

          .terms-content-body {
            padding: 40px !important;
          }
        }

        /* Extra small devices */
        @media (max-width: 575px) {
          .terms-page {
            padding-top: 15px !important;
            padding-bottom: 30px !important;
          }

          .terms-header-icon {
            width: 60px !important;
            height: 60px !important;
          }

          .terms-header-icon-svg {
            font-size: 30px !important;
          }

          .terms-main-title {
            font-size: 1.75rem !important;
          }

          .terms-subtitle {
            font-size: 0.9rem !important;
          }

          .terms-updated-date {
            font-size: 0.8rem !important;
          }

          .terms-content-body {
            padding: 16px !important;
          }

          .terms-section {
            margin-bottom: 1.5rem !important;
          }

          .terms-section-title {
            font-size: 1.3rem !important;
          }

          .terms-section-text {
            font-size: 0.85rem !important;
            line-height: 1.6 !important;
          }

          .terms-list {
            font-size: 0.85rem !important;
            line-height: 1.7 !important;
            padding-left: 18px !important;
          }

          .terms-table {
            font-size: 0.8rem !important;
          }

          .terms-table th,
          .terms-table td {
            padding: 6px 8px !important;
            font-size: 0.8rem !important;
          }

          .terms-commitment-text {
            font-size: 0.85rem !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TermsAndConditions; 
